// extracted by mini-css-extract-plugin
export default {"wrapper":"ControlTaskList_wrapper__-Hb9Z","page":"ControlTaskList_page__Huj++"};